"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadProgress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
require("../style/file-management.css");
const tooltip_1 = require("primereact/tooltip");
const progressbar_1 = require("primereact/progressbar");
const utils_1 = require("primereact/utils");
const UploadProgress = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common']);
    const status = props.useAppSelector((state) => state.importData);
    const uploadRef = (0, react_1.useRef)(null);
    const [started, setStarted] = (0, react_1.useState)(false);
    const [startedClass, setStartedClass] = (0, react_1.useState)('begin');
    const [percentage, setPercentage] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        setStarted(status.uploadTotal > 0);
        let tempPercentage = (status.uploadCount / status.uploadTotal * 100) / 2;
        if (status.uploadStep === '2/2') {
            tempPercentage += 50;
        }
        setPercentage(tempPercentage);
    }, [status]);
    (0, react_1.useEffect)(() => {
        console.log('%', percentage);
    }, [percentage]);
    (0, react_1.useEffect)(() => {
        if (started) {
            // console.log('upload started');
            setTimeout(() => {
                setStartedClass('started');
            }, 2000);
        }
    }, [started]);
    const getStatusTooltip = () => {
        return percentage.toFixed(0) + '%\n' +
            t('step') + ': ' + status.uploadStep + '\n' +
            status.uploadCount + '/' + status.uploadTotal + '\n' +
            status.uploadType;
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: started &&
            (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: uploadRef, className: (0, utils_1.classNames)('upload-status card', startedClass), style: { left: uploadRef.current && startedClass !== 'started' ? (window.innerWidth / 2) - (uploadRef.current.clientWidth / 2) : undefined } }, { children: (0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "layout-inline-menu-action-panel absolute", style: { left: '2px', bottom: '3px' } }, { children: (0, jsx_runtime_1.jsx)("li", Object.assign({ className: "layout-inline-menu-action-item -mb-1", style: { cursor: 'default' } }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: ".statusTooltip", position: 'top' }), (0, jsx_runtime_1.jsxs)("button", Object.assign({ className: "p-link statusTooltip", style: { paddingLeft: '12px' }, "data-pr-tooltip": getStatusTooltip() }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-cloud-upload" }), (0, jsx_runtime_1.jsx)(progressbar_1.ProgressBar, { value: percentage, color: 'green', showValue: false, className: 'w-full' })] }))] }) })) })) })) }));
};
exports.UploadProgress = UploadProgress;
